export const imageCodes = {
  img1: {
    code: "${merchantId}_tmpl_img_1",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03919.jpg?alt=media&token=37efbbf2-deb5-41ef-82cc-ecbeb6ea54c7",
  },
  img2: {
    code: "${merchantId}_tmpl_img_2",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP03536%20(1).jpg?alt=media&token=4456712b-8231-4e36-8d41-8e9cd82f18b2",
  },
  img3: {
    code: "${merchantId}_tmpl_img_3",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01351.jpg?alt=media&token=8c2672bc-8621-45f8-b689-dbbf66d06aba ",
  },
  img4: {
    code: "${merchantId}_tmpl_img_4",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01327%20(1).jpg?alt=media&token=87ca9475-6edd-4041-be8d-8822c0ad8ce2",
  },
  img5: {
    code: "${merchantId}_tmpl_img_5",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01028%20(1).jpg?alt=media&token=61b0836b-8d80-4556-b59b-c899de73e14cttps://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP01028.jpg?alt=media&token=cd63e31d-6c4f-4898-ba54-5170ffc8a36a",
  },
  img6: {
    code: "${merchantId}_tmpl_img_6",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLHP00956.jpg?alt=media&token=28f04299-fe98-4cf1-8a27-a0b7a12d9ebe",
  },
};
export const faqCode = {
  shipping: {
    code: "${merchantId}_tmpl_img_8",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FShipping%20(1).jpg?alt=media&token=cb094a7b-3eb6-4f7c-81e0-e804d1f17a13",
  },
  returns: {
    code: "${merchantId}_tmpl_img_9",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FReturns%20(1).jpg?alt=media&token=fa34888c-6c57-471a-9638-56b78c472b2a",
  },
  laundry_care: {
    code: " ${merchantId}_tmpl_img_10",
    image:
      "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2FLaundry%20Care%20(1).jpg?alt=media&token=d7bbf7be-899d-41e9-b625-2addda3447ee",
  },
};
